"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEditor = void 0;

var _Attachment = _interopRequireDefault(require("./Attachment"));

var _Checkbox = _interopRequireDefault(require("./Checkbox"));

var _Date = _interopRequireDefault(require("./Date"));

var _LinkToRecord = _interopRequireDefault(require("./LinkToRecord"));

var _LongText = _interopRequireDefault(require("./LongText"));

var _MultiSelect = _interopRequireDefault(require("./MultiSelect"));

var _Number = _interopRequireDefault(require("./Number"));

var _SingleSelect = _interopRequireDefault(require("./SingleSelect"));

var _Text = _interopRequireDefault(require("./Text"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var getEditor = function getEditor(type) {
  if (["singleLineText", "phoneNumber", "password", "email", "url", "barcode"].includes(type)) {
    return _Text["default"];
  }

  if (["number", "currency", "percent", "duration"].includes(type)) {
    return _Number["default"];
  }

  if (type === "longText") {
    return _LongText["default"];
  }

  if (type === "date") {
    return _Date["default"];
  }

  if (type === "linkToRecord") {
    return _LinkToRecord["default"];
  }

  if (type === "collaborator") {
    return _LinkToRecord["default"];
  }

  if (type === "attachment") {
    return _Attachment["default"];
  }

  if (type === "singleSelect") {
    return _SingleSelect["default"];
  }

  if (type === "multiSelect") {
    return _MultiSelect["default"];
  }

  if (type === "checkBox") {
    return _Checkbox["default"];
  }

  return null;
};

exports.getEditor = getEditor;